import React from 'react'
import PropTypes from 'prop-types'
import * as cloudinary from '../../lib/util/cloudinary'
import * as s3 from '../../lib/util/s3'

const Image = ({ image = {}, alt, options = {}, className, style = {} }) => {
  if (!image) {
    return null
  }

  const provider = s3.exists(image) ? s3 : cloudinary.exists(image) ? cloudinary : null

  if (!provider) {
    return null
  }

  const { isImageType, url } = provider

  const { format } = options
  const isImage = isImageType(image)
  const src = url(options, image)

  if (!src) {
    return null
  }

  if (isImage || format === 'jpg') {
    return <img className={className} alt={alt} src={src} style={style} />
  } else {
    const poster = url({ ...options, format: 'jpg' }, image)
    return (
      <video controls controlsList="nodownload nofullscreen noremoteplayback" poster={poster} className={className} style={style}>
        <source src={src} />
      </video>
    )
  }
}

Image.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  options: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Image
